var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-installation-details"},[_c('vx-spinner',{ref:"spinner",attrs:{"image":_vm.globals.assetsPath+'images/spinner.gif',"full-screen":""}}),_vm._v(" "),_c('p',{attrs:{"tabindex":"0"}},[_vm._v(_vm._s(_vm.installationDetails.description)+"\r\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd6d93b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/manage-shopping-cart/vx-installation-details/vx-installation-details.html
// module id = null
// module chunks = 